import { SceneWithUserNames } from '../../types/scene.types';
import { BreakdownInfo } from '../../pages/Home/types';
import {
  SlotDataCache,
  ScheduleDataCache,
  ElementDataCache,
  ElementRelationDataCache
} from '../../types/cache.types';
import { exportElementShootingDatesSummaryExcel } from './Templates/Excel-ElementShootingDatesSummary';
import { exportElementShootingDatesDetailExcel } from './Templates/Excel-ElementShootingDatesDetail';
import { exportElementQTYExcel } from './Templates/Excel-ElementQTY';

// 语言类型定义
export type SupportedLanguage = 'zh-CN' | 'zh-HK' | 'en';
export type ExcelTemplateId =
  | 'breakdown-data-excel'
  | 'element-shooting-dates-summary-excel'
  | 'element-shooting-dates-detail-excel'
  | 'element-qty-excel';

// 导出Excel函数，供外部调用
export const exportExcel = (
  scenes: SceneWithUserNames[],
  breakdownInfo: BreakdownInfo,
  language: SupportedLanguage = 'zh-CN',
  secondaryLanguage: SupportedLanguage | undefined,
  templateId: ExcelTemplateId = 'breakdown-data-excel',
  breakdownId?: string,
  effectiveScheduleId?: string | null,
  scheduleDetailCalDateBounds?: { start: string; end: string },
  getScheduleCache?: (breakdownId: string) => ScheduleDataCache | null,
  getSlotCache?: (scheduleId: string) => SlotDataCache | null,
  getElementCache?: (breakdownId: string) => ElementDataCache | null,
  getElementRelationCache?: (breakdownId: string) => ElementRelationDataCache | null,
  onProgress?: (progress: number) => void
): Promise<void> => {
  if (templateId === 'element-shooting-dates-summary-excel') {
    return exportElementShootingDatesSummaryExcel(
      breakdownInfo,
      language,
      secondaryLanguage,
      breakdownId,
      effectiveScheduleId,
      getSlotCache,
      getElementCache,
      getElementRelationCache,
      onProgress
    );
  }

  if (templateId === 'element-shooting-dates-detail-excel') {
    return exportElementShootingDatesDetailExcel(
      breakdownInfo,
      language,
      secondaryLanguage,
      breakdownId,
      effectiveScheduleId,
      getSlotCache,
      getElementCache,
      getElementRelationCache,
      onProgress
    );
  }

  if (templateId === 'element-qty-excel') {
    return exportElementQTYExcel(
      breakdownInfo,
      language,
      secondaryLanguage,
      breakdownId,
      effectiveScheduleId,
      scheduleDetailCalDateBounds,
      getScheduleCache,
      getSlotCache,
      getElementCache,
      getElementRelationCache,
      onProgress
    );
  }

  return import('./Templates/Excel-Breakdown').then((mod) =>
    mod.exportScenesAndSetsExcel(
      scenes,
      breakdownInfo,
      language,
      secondaryLanguage,
      breakdownId,
      getElementCache,
      getElementRelationCache,
      onProgress
    )
  );
};
